import React from "react";

class Coverages extends React.Component {
  render() {
    return (
        <section id="coverages" className="section" style={{background: "#fff", padding: "60px 0"}}>
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center section_title">
                <h2 className="font-weight-bold wherehome">
                  MIGHTYWIFI AND GLOBAL PARTNERS<br/>HAVE SERVICED OVER 60 MILLION USERS WORLDWIDE
                </h2>
                <h5 className="coverages">
                  <ul>
                    <li>Operating since 2003 as a cross-border telecommunications service provider, providing mobile hotspots and SIM cards</li>
                    <li>Our partners have offices in the U.S., China, South Korea, Japan, Singapore, Thailand, and Europe</li>
                    <li>Our global data serves over 100 countries, and the list continues to grow</li>
                  </ul>
                </h5>
                {/*<h4 class="coverages">
                  MightyWifi and our global partners have handled more than
                  <strong class="inverted">
                    <span class="counter">6</span>
                  </strong>
                  million transactions<br/> and delivered over
                  <strong class="inverted">
                    <span class="counter">42</span>
                  </strong>
                  million GB of data thus far.
                </h4>*/}
              </div>
            </div>
          </div>
          <div className="coverages map"></div>
          {/*U.S. Coverage Map*/}
          <div className="row" style={{padding: "60px 0 10px 0"}}>
            <div className="col-lg-12">
              <div className="text-center section_title">
                <h2 className="font-weight-bold wherehome">
                  U.S. Coverage Map
                </h2>
                <img className="coveragesMap" src="../images/us-coverage.jpg"/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center section_title">
                <h5>Please contact us at <a href="mailto:support@mightywifi.net">support@mightywifi.net</a> or 201-731-3839 for detail</h5>
              </div>
            </div>
          </div>
          {/*U.S. Coverage Map*/}
        </section>
    );
  }
}

export default Coverages;



// WEBPACK FOOTER //
// ./src/layout/Coverages.js